import { MenuProps } from '../components';

export const getDropdownMaxHeight = (size: MenuProps['size']) => {
  if (size === 'small') {
    return '196px';
  }

  return '236px';
};
